const _excluded = ["buttonProps", "callbacks", "children", "focus", "id", "includeInputLabels", "render", "style"],
  _excluded2 = ["isLoading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as r from "react";
import { useForm as z } from "../../contexts/form/form.es.mjs";
import { useEventListener as O } from "../../hooks/use-event-listener.es.mjs";
import { LoadingCard as P, PayButton as S } from "./gift-card.styles.es.mjs";
function F(_ref) {
  let _ref$buttonProps = _ref.buttonProps,
    y = _ref$buttonProps === void 0 ? {
      id: "rswps-gift-card-button"
    } : _ref$buttonProps,
    s = _ref.callbacks,
    C = _ref.children,
    f = _ref.focus,
    _ref$id = _ref.id,
    i = _ref$id === void 0 ? "rswps-gift-card-container" : _ref$id,
    u = _ref.includeInputLabels,
    d = _ref.render,
    l = _ref.style,
    h = _objectWithoutProperties(_ref, _excluded);
  const _r$useState = r.useState(() => {}),
    _r$useState2 = _slicedToArray(_r$useState, 2),
    a = _r$useState2[0],
    E = _r$useState2[1],
    _r$useState3 = r.useState(!1),
    _r$useState4 = _slicedToArray(_r$useState3, 2),
    v = _r$useState4[0],
    m = _r$useState4[1],
    _z = z(),
    R = _z.cardTokenizeResponseReceived,
    w = _z.payments,
    b = r.useRef(null),
    k = r.useMemo(() => {
      const e = {
        includeInputLabels: u,
        style: l
      };
      return Object.keys(e).reduce((t, n) => (e[n] !== void 0 && (t[n] = e[n]), t), {});
    }, [u, l]),
    G = async e => {
      if (e.stopPropagation(), !a) {
        console.warn("Gift Card button was clicked, but no Gift Card instance was found.");
        return;
      }
      m(!0);
      try {
        const t = await a?.tokenize();
        if (t.status === "OK") return await R(t);
        let n = `Tokenization failed with status: ${t.status}`;
        if (t?.errors) throw n += ` and errors: ${JSON.stringify(t?.errors)}`, new Error(n);
        console.warn(n);
      } catch (t) {
        console.error(t);
      } finally {
        m(!1);
      }
    };
  if (r.useEffect(() => {
    const e = new AbortController(),
      t = e.signal;
    return (async o => {
      const c = await w?.giftCard(k).then(p => o.aborted ? null : (E(p), p));
      await c?.attach(`#${i}`), f && (await c?.focus(f)), o.aborted && (await c?.destroy());
    })(t), () => {
      e.abort();
    };
  }, [w, i]), s) for (const e of Object.keys(s)) a?.addEventListener(e, s[e]);
  O({
    listener: G,
    type: "click",
    element: b,
    options: {
      passive: !0
    }
  });
  const g = _ref2 => {
    let e = _ref2.isLoading,
      t = _objectWithoutProperties(_ref2, _excluded2);
    const n = "rswp-gift-card-button",
      o = e || !a || v;
    return /* @__PURE__ */r.createElement(S, _objectSpread(_objectSpread({}, t), {}, {
      "aria-disabled": o,
      css: t?.css,
      disabled: o,
      id: n,
      ref: b,
      type: "button"
    }), t?.children ?? "Pay with Gift Card");
  };
  return /* @__PURE__ */r.createElement(r.Fragment, null, /* @__PURE__ */r.createElement("div", _objectSpread(_objectSpread({}, h), {}, {
    "data-testid": "rswps-gift-card-container",
    id: i,
    style: {
      minHeight: 89
    }
  }), !a && /* @__PURE__ */r.createElement(P, null)), typeof d == "function" ? d(g) : /* @__PURE__ */r.createElement(g, _objectSpread({}, y), C ?? "Pay with Gift Card"));
}
export { F as default };